import { useState, useEffect, useContext } from "react";
import "./Transactions.css";
import Colors from "../../../Helper/Colors";
import { Modal, Button, Spin } from "antd";
import { useSelector } from "react-redux";
import { techappContext } from "../../../Api/techappReq";
import FormatHelper from "../../../Helper/FormatHelper";
import plusImage from "../../../assets/images/plus.svg";
import TransactionCard from "../transaction_card/index";
import InputSeperator from "../input_seperator";
import PN from "persian-number";
import { toast } from "react-toastify";
import Empty from "../empty";
import Header from "../header";
import { useNavigate } from "react-router-dom";
import Layout from "../../../layout";

const Transactions = () => {
  const navigate = useNavigate();
  const [isDepositVisible, setIsDepositVisible] = useState(false);
  const [isInitVisible, setIsInitVisible] = useState(false);
  const [finalConfirm, setFinalConfirm] = useState(false);
  const [portModal, setPortModal] = useState(false);
  const profileData = useSelector((state) => state.TechAppReducer.profileData);
  const transactionsData = useSelector(
    (state) => state.TechAppReducer.transactionsData
  );
  const [amount, setAmount] = useState("");
  const [portValue, setPortValue] = useState("");

  const [collapsedStatus, setCollapsedStatus] = useState(true);

  const deposit = () => {
    setIsDepositVisible(false);
  };

  const finalInit = () => {
    if (ports.length === 1) {
      initPaymentReq(amount, ports[0].port);
    } else {
      setPortModal(true);
    }
  };

  const {
    profile,
    transactions,
    loading,
    getPorts,
    ports,
    initPaymentReq,
    page,
    setPage,
    hasMore,
    transactionsPaginateLoading,
    isFetchingRef,
  } = useContext(techappContext);

  const isAdmin = !!localStorage.getItem("auth_from_admin");

  const initPayment = () => {
    if (amount.length === 0) {
      toast.warning("مبلغ نباید خالی باشد");
    } else if (parseFloat(amount) < 1000) {
      toast.warning("مبلغ نباید کمتر از ۱,۰۰۰ تومان باشد");
    } else if (parseFloat(amount) > 30000000) {
      toast.warning("مبلغ نمیتواند بیشتر از ۳۰‍‍‍,۰۰۰,۰۰۰ تومان باشد");
    } else {
      setIsInitVisible(true);
    }
  };

  const goToPayment = () => {
    if (portValue?.length === 0) {
      toast.warning("لطفا درگاه بانکی مورد نظر را انتخاب کنید");
    } else {
      initPaymentReq(amount, portValue);
    }
  };

  const depositStartHandler = () => {
    setIsDepositVisible(true);
  };

  useEffect(() => {
    if (isAdmin) {
      transactions(1, 10, false);
    } else {
      transactions(1, 10, false);
    }
    setPage(1);
    profile();
  }, []);

  useEffect(() => {
    if (!isAdmin) return;

    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >=
        document.body.offsetHeight - 300
      ) {
        loadMore();
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []); // ✅ runs only once

  const loadMore = () => {
    if (isFetchingRef.current) return; // already fetching
    if (loading || transactionsPaginateLoading) return; // prevent multiple calls
    if (!hasMore) return;

    isFetchingRef.current = true;
    setPage((prev) => prev + 1);
  };

  useEffect(() => {
    if (page > 1) {
      transactions(page, 10, true);
    }
  }, [page]);

  useEffect(() => {
    if (isInitVisible) {
      getPorts();
    }
  }, [isInitVisible]);

  return (
    <Layout>
      <div className="tech-app-transactions">
        <Header
          backHandler={() => {
            navigate("/techapp/profile");
          }}
          title={"تراکنش ها"}
        />
        <div className="tech-app-transaction-body">
          <div className="tech-app-current-charge">
            اعتبار فعلی :{" "}
            <span
              style={
                profileData?.balance > 0
                  ? { color: Colors.success }
                  : {
                      color: Colors.danger,
                      direction: "ltr",
                      letterSpacing: "1px",
                    }
              }
            >
              {profileData?.balance
                ? FormatHelper.toPersianString(
                    FormatHelper.numberSeperator(profileData.balance.toFixed(0))
                  )
                : "۰"}
            </span>
            تومان
          </div>
          {!loading && transactionsData?.length === 0 && (
            <Empty title={"تراکنشی یافت نشد."} />
          )}
          {!loading && transactionsData?.length > 0 && (
            <div className="tech-app-transaction-expand-switch-container">
              <div className="tech-app-transaction-expand-switch" onClick={()=>setCollapsedStatus(collapsedStatus === true ? false : true)}>{collapsedStatus ? 'نمایش' : 'مخفی کردن'} جزییات</div>
            </div>
          )}
          {!loading &&
            transactionsData?.length > 0 &&
            transactionsData.map((trans, index) => (
              <TransactionCard
                transaction={trans}
                key={index}
                profileData={profileData}
                collapsedStatus={collapsedStatus}
              />
            ))}
          {loading && (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                marginTop: "100px",
              }}
            >
              <Spin size="large" />
            </div>
          )}
          {transactionsPaginateLoading ? (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Spin />
            </div>
          ) : null}
        </div>
        {/* add button */}
        <div
          onClick={() => {
            if (!localStorage.getItem("auth_from_admin")) {
              depositStartHandler();
            } else {
              toast.error("شما از پنل ادمین وارد شده اید و دسترسی ندارید.");
            }
          }}
          style={
            localStorage.getItem("auth_from_admin")
              ? {
                  backgroundColor: Colors.warning,
                  filter: "blur(1px)",
                  cursor: "not-allowed",
                }
              : { backgroundColor: Colors.warning }
          }
          className="tech-app-transaction-deposit"
          id="transactions_init_payment_button"
        >
          <img style={{ width: "25%" }} src={plusImage} alt="deposit money" />
        </div>
        {/* deposit modal */}
        <Modal
          ariaHideApp={false}
          open={isDepositVisible}
          onOk={initPayment}
          onCancel={deposit}
          style={{ borderRadius: "6px", textAlign: "center" }}
          title={"افزایش اعتبار"}
          footer={[
            <>
              <Button
                onClick={deposit}
                className="tech-app-reset-data-btns btn-text-black"
                style={{
                  backgroundColor: "rgba(199, 199, 199, 0.322)",
                  color: "black",
                }}
              >
                انصراف
              </Button>
              <Button
                onClick={initPayment}
                className="tech-app-reset-data-btns btn-text-white"
                id="transactions_deposit_amount_submit_button"
                style={{ backgroundColor: Colors.royalBlue, color: "white" }}
              >
                ثبت
              </Button>
            </>,
          ]}
        >
          <InputSeperator
            value={amount}
            setValue={setAmount}
            className={"ant-input transactions_deposit_amount_input"}
            placeHolder="مبلغ به تومان"
            style={{
              width: "100%",
              maxHeight: "100px",
              textAlign: "right",
              borderRadius: "6px",
              marginBottom: "10px",
            }}
          />
        </Modal>
        {/* confirm modal */}
        <Modal
          ariaHideApp={false}
          open={isInitVisible}
          onOk={() => {
            if (parseFloat(amount) > 1000000) {
              setFinalConfirm(true);
            } else {
              finalInit();
            }
          }}
          onCancel={() => setIsInitVisible(false)}
          style={{ borderRadius: "6px", textAlign: "center" }}
          title={
            <span style={{ color: Colors.danger }}>
              تایید مبلغ افزایش اعتبار
            </span>
          }
          footer={[
            <>
              <Button
                onClick={() => setIsInitVisible(false)}
                className="tech-app-reset-data-btns btn-text-black"
                style={{
                  backgroundColor: "rgba(199, 199, 199, 0.322)",
                  color: "black",
                }}
              >
                خیر
              </Button>
              <Button
                onClick={() => {
                  if (parseFloat(amount) > 1000000) {
                    setFinalConfirm(true);
                  } else {
                    finalInit();
                  }
                }}
                className="tech-app-reset-data-btns btn-text-white"
                id="transactions_deposit_amount_confirm_button"
                style={{ backgroundColor: Colors.royalBlue, color: "white" }}
              >
                بله
              </Button>
            </>,
          ]}
        >
          مبلغ{" "}
          <span style={{ backgroundColor: "#fcc603", padding: "0 5px" }}>
            {amount && PN.convert(amount)}
          </span>{" "}
          تومان به اعتبار حساب شما اضافه خواهد شد , آیا مورد تایید است؟ (مبالغ
          به صورت رند وارد شود مانند : ۲۰۰ هزار تومان یا ۲۵۰ هزار تومان)
        </Modal>
        {/* final confirm modal */}
        <Modal
          ariaHideApp={false}
          open={finalConfirm}
          onOk={finalInit}
          onCancel={() => setFinalConfirm(false)}
          style={{ borderRadius: "6px", textAlign: "center" }}
          title={
            <span style={{ color: Colors.danger }}>
              بررسی و تایید نهایی مبلغ به تومان
            </span>
          }
          footer={[
            <>
              <Button
                onClick={() => setFinalConfirm(false)}
                className="tech-app-reset-data-btns btn-text-black"
                style={{
                  backgroundColor: "rgba(199, 199, 199, 0.322)",
                  color: "black",
                }}
              >
                خیر
              </Button>
              <Button
                onClick={finalInit}
                className="tech-app-reset-data-btns btn-text-white"
                id="transactions_deposit_final_confirm_button"
                style={{ backgroundColor: Colors.royalBlue, color: "white" }}
              >
                بله
              </Button>
            </>,
          ]}
        >
          مبلغ{" "}
          <span style={{ backgroundColor: "#fcc603", padding: "0 5px" }}>
            {amount && PN.convert(amount)}
          </span>{" "}
          تومان به حساب شما اضافه خواهد شد دقت فرمایید مبلغ وارد شده به{" "}
          <span style={{ backgroundColor: "#fcc603", padding: "0 5px" }}>
            تومان
          </span>{" "}
          می باشد، مورد تایید است؟
        </Modal>
        {/* port modal */}
        <Modal
          ariaHideApp={false}
          open={portModal}
          onOk={goToPayment}
          onCancel={() => setPortModal(false)}
          style={{ borderRadius: "6px", textAlign: "center" }}
          title={"انتخاب درگاه بانکی"}
          footer={[
            <>
              <Button
                onClick={() => setPortModal(false)}
                className="tech-app-reset-data-btns btn-text-black"
                style={{
                  backgroundColor: "rgba(199, 199, 199, 0.322)",
                  color: "black",
                }}
              >
                انصراف
              </Button>
              <Button
                onClick={goToPayment}
                className="tech-app-reset-data-btns btn-text-white"
                style={{ backgroundColor: Colors.royalBlue, color: "white" }}
              >
                پرداخت
              </Button>
            </>,
          ]}
        >
          <div className="transactions-ports">
            {ports?.map((port, index) => (
              <div
                key={index}
                onClick={() => setPortValue(port.port)}
                className={`transactions-port-item ${
                  portValue === port.port ? "transactions-port-selected" : ""
                }`}
              >
                <img src={port?.icon} alt="port icon" />
                <span>{port?.persian_title}</span>
              </div>
            ))}
          </div>
        </Modal>
      </div>
    </Layout>
  );
};
export default Transactions;
